module.exports = __webpack_public_path__ + "img/imseologo.cc61eb47.png";